import { StructureModal } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

interface IAssetAddedModalProps {
    isOpen: boolean;
    title: string;
    buttonText: string;
    onClick: () => void;
    onClose?: () => void;
}

export const AssetAddedModal: React.FC<IAssetAddedModalProps> = ({ isOpen, title, buttonText, onClick, onClose }) => {
    const handleOnClose = () => {
        onClose?.();
    };

    return (
        <StructureModal
            isOpen={isOpen}
            showHeaderDivider={false}
            contentPadding={"16px 24px 24px 32px"}
            customStyles={{ content: { width: "400px", height: "353px" } }}
            title={title}
            mainButton={{ label: buttonText, onClick, tooltipEnabled: false }}
            secondaryButton={{
                label: translate("project.preview.AssetAddedModal.close"),
                onClick: () => handleOnClose(),
                type: "flat",
                tooltipEnabled: false,
            }}
        >
            <img
                width="352px"
                height="196px"
                src={AssetsService.assetUrl("/images/project-setup/blog-image.png")}
            />
        </StructureModal>
    );
};
